import loadable from '@loadable/component';

export const sharedComponentsLoader = ({ componentName }) => loadable(() => import(/* webpackChunkName: "async-[request]" */`shared-components/components/DynamicPanels/${componentName}`), { ssr: false });
export const portalLoader = ({ componentName }) => loadable(() => import(/* webpackChunkName: "async-[request]" */`../../modals/partials/QueryBuilder/${componentName}`), { ssr: false });
